import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TimeOfFlight } from './pipes/time-of-flight.pipe';
import { DictionaryPipe } from './pipes/dictionary.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { CustomDatePipe } from './pipes/date-custom.pipe';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [TimeOfFlight, DictionaryPipe, SafePipe, FirstLetterPipe, CustomDatePipe],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    })
  ],
  exports: [
    TranslateModule,
    TimeOfFlight,
    DictionaryPipe,
    SafePipe,
    FirstLetterPipe,
    CustomDatePipe
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
